<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content v-if="userData">
      <b-avatar
        size="30"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal mx-1"
        badge-variant="success"
      >
        <feather-icon v-if="!userData.fullName" icon="UserIcon" size="22" />
      </b-avatar>
      <div class="d-sm-flex d-none user-nav mr-2">
        <p class="user-name mb-0 color-black">
          {{ userData.fullName || userData.username }}
        </p>
        <!-- <span class="user-status">{{ userData.role }}</span> -->
      </div>
    </template>

    <b-dropdown-item
      :to="{ name: 'pages-profile' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>{{ $t("profile") }}</span>
    </b-dropdown-item>

    <!-- <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="HelpCircleIcon"
        class="mr-50"
      />
      <span>FAQ</span>
    </b-dropdown-item> -->
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>{{ $t("logout") }}</span>
    </b-dropdown-item></b-nav-item-dropdown
  >
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}
const images = importAll(
  require.context("@/assets/images/avatars/", false, /.(png)$/)
);

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      localStorageKey: "userData",
      // userData: JSON.parse(localStorage.getItem("userData")),
      avatarText,
    };
  },
  computed: {
    userData() {
      const storedData = localStorage.getItem(this.localStorageKey);
      return storedData ? JSON.parse(storedData) : null;
    },
  },
  created() {
    // Thêm sự kiện lắng nghe cho sự thay đổi trong Local Storage
    window.addEventListener("storage", this.handleStorageChange);
  },
  watch: {
    // Theo dõi sự thay đổi của Local Storage
    userData(newValue) {
      // Handle sự thay đổi ở đây, newValue chứa giá trị mới của userData
      console.log("UserData has changed:", newValue);
    },
  },
  methods: {
    handleStorageChange(event) {
      // Kiểm tra xem sự kiện thay đổi có liên quan đến key chúng ta quan tâm hay không
      if (event.key === this.localStorageKey) {
        // Xử lý sự thay đổi, event.newValue chứa giá trị mới
        console.log("UserData has changed in another tab:", event.newValue);
        // reload web 
        window.location.reload();
      }
    },
    getImg(pic) {
      return images[pic];
    },
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

      // Remove userData from localStorage
      localStorage.removeItem("userData");

      // Reset ability
      this.$ability.update(initialAbility);
      this.$store.commit("masterData/SET_MENU", null);
      // Redirect to login page
      this.$router.push({ name: "auth-login" });
    },
  },
};
</script>
